
import { computed, defineComponent, PropType } from 'vue'

import Cheap from '@/common/components/UI/Cheap/index.vue'

export default defineComponent({
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    components: { Cheap },
    setup(props) {
        const getType = computed(() => {
            if (props.row) {
                if (props.row.isTake) return 'Забор'
                if (props.row.isDelivery) return 'Доставка'
            }

            return '-'
        })

        const getCheckOrTimesIcon = (is_check: boolean) =>
            `fas ${is_check ? 'fa-check text-green-500' : 'fa-times'}`

        const isAnswer = computed(() => {
            return (
                props.row.waitList &&
                props.row.waitList.state &&
                [48, 49].includes(props.row.waitList.state.id)
            )
        })

        return { getType, getCheckOrTimesIcon, isAnswer }
    },
})
